import { GetAvailablePlansRequest } from '../account/dto/request/get-available-plans.request';
import { GetAvailablePlansResponse } from '../account/dto/response/get-available-plans.response';
import { api } from '../../api';
import { getAvailablePlansQuery } from './account-plan.toolkit-queries';

export const accountPlanEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    getAvailablePlans: builder.query<GetAvailablePlansResponse, GetAvailablePlansRequest>({
      query: getAvailablePlansQuery,
    }),
  }),
});

export const { useGetAvailablePlansQuery } = accountPlanEndpoints;
